export {TisaDestroyService} from './destroy.service';
